import React from 'react';

import * as dateish from 'js/dateish';
import { assertUnreachable } from 'js/asserts';

type LinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & { children: React.ReactNode }

export const doyURL = (doy: dateish.DoY) => `#/date?doy=${doy}`;
export const moyURL = (moy: dateish.MoY) => `#/date?moy=${moy}`;

export const dateishURL = ({ kind, value }: dateish.Any) => {
  switch (kind) {
    case 'doy': return doyURL(value);
    case 'moy': return moyURL(value);
  }
  assertUnreachable('dateish kind', kind);
}

export const LinkDateish = (props: LinkProps & { date: dateish.Any }) => {
  const { date, children, ...rest } = props;
  return <a href={ dateishURL(date) } { ...rest }>{ children }</a>;
}

export const LinkDoY = (props: LinkProps & { doy: dateish.DoY }) => {
  const { doy, children, ...rest } = props;
  return <a href={ doyURL(doy) } { ...rest }>{ children }</a>;
}

export const LinkMoY = (props: LinkProps & { moy: dateish.MoY }) => {
  const { moy, children, ...rest } = props;
  return <a href={ moyURL(moy) } { ...rest }>{ children }</a>;
}
